import React from 'react'
import { integrationFavicons } from 'common/Enums'
import { DefaultKavkomIntegration } from 'common/Globals'
import { createGlobalStyle } from 'styled-components'

let config = {}

try {
    config = require('../../public/whitelabel.config.json')
} catch {}

const DefaultConfig = {
    colors: {
        primary: '#238cf5',
        'primary-disabled': 'rgba(35, 140, 245, 0.4)',
        'primary-hover': '#0a73db',
        secondary: '#ff8717',
        'secondary-disabled': 'rgba(255, 135, 23, 0.4)',
        'secondary-hover': '#e36e00',
        red: '#eb4770',
        'red-hover': '#e9305e',
        header: '#12263a',
        'header-opaque': 'rgba(18,38,58,.92)',
        'header-title': '#8aa7c1',
        footer: '#fff',
        text: '#4c769c',
        'secondary-text': '#8aa6c1',
        'page-title': '#4f7396',
        link: '#238cf5',
        bg: '#fcfcfc',
        body: '#202a35',
        green: '#4ECAA8',
        blue: '#238cf5',
        'gray-100': '#eaeaea',
        'gray-200': '#86a7c3',
        'gray-300': '#cdd9e5',
        'gray-400': '#698db0',
        'gray-500': '#8aa7c1',
        'volume-meter-point-hsl': '210, 91% , 55%',
        pickupButtonColor: 'var(--primary)',
        pickupButtonHoverColor: 'var(--primary-hover)',
        blueBadgeBackground: 'rgb(231, 243, 254)',
        blueBadgeColor: 'rgb(84, 166, 247)',
        greenBadgeBackground: 'rgb(235, 249, 245)',
        greenBadgeColor: 'rgb(118, 214, 187)',
        orangeBadgeBackground: 'rgb(254, 245, 231)',
        orangeBadgeColor: 'rgb(243, 165, 38)',
        redBadgeBackground: 'rgb(252, 232, 237)',
        redBadgeColor: 'rgb(242, 140, 166)',
        changePasswordBackground: 'rgba(35, 140, 245, 0.2)',
        changePasswordColor: 'var(--link)',
        changePasswordHoverBackground: 'rgba(35, 140, 245, 0.4)',
        changePasswordHoverColor: 'var(--link)',
    }
}

export const useThemeWhitelabelConfig = () => {
    const { hostname } = window.location
    let selectedHostname = 'default'

    for (const domain in config) {
        if (hostname.includes(domain)) {
            selectedHostname = domain
            break
        }
    }

    const selectedConfig = config[selectedHostname] || DefaultConfig

    if (selectedConfig?.logo?.small?.hasOwnProperty('url')) {
        DefaultKavkomIntegration.logo = selectedConfig.logo.small.url
        DefaultKavkomIntegration.logoParams = {
            width: selectedConfig.logo.small?.width,
            height: selectedConfig.logo.small?.height
        }

        integrationFavicons[DefaultKavkomIntegration.key] = (
            <img
                src={selectedConfig.logo.small.url}
                alt={`${selectedConfig.name} Logo`}
                width={selectedConfig.logo.small?.width || 19}
                height={selectedConfig.logo.small?.height || 'auto'}
            />
        )
    }

    if (selectedConfig.hasOwnProperty('name')) {
        DefaultKavkomIntegration.name = selectedConfig.name
    }

    const colors = selectedConfig.hasOwnProperty('colors')
        ? { ...DefaultConfig.colors, ...selectedConfig.colors }
        : DefaultConfig.colors

    return {
        key: selectedHostname,
        ...selectedConfig,
        colors
    }
}

export const useThemeWhitelabelColors = (config = WhitelabelConfig) => {
    const { colors } = config

    const colorsArray = Object.keys(colors)

    return createGlobalStyle`
            :root {
                ${colorsArray.map(function (key) {
                    return `--${key}: ${colors[key]};`
                })}
            }
        `
}

export const WhitelabelConfig = useThemeWhitelabelConfig()
